<div [class]="additionalClass">
  <div class="suite-info__beds">
    <ng-container *ngFor="let space of orderedSpaces">
      <ng-container *ngIf="space.value">
        <span class="suite-info__bed">
          <i *ngIf="space.icon" class="fa-regular fa-{{ space.icon }} suite-info__bed-icon"></i>
          {{ space.value }}
          {{ space.value !== 1 && space.namePlural ? space.namePlural : space.name }}
        </span>
      </ng-container>
    </ng-container>
  </div>
</div>
